import useSnackbarContext, {type ShowSnackbarFunction} from 'contexts/SnackbarContext';

export {type ShowSnackbarFunction};

const useSnackbar = () => {
  const {
    errorSnackbar,
    successSnackbar,
    warningSnackbar,
    infoSnackbar
  } = useSnackbarContext();
  return {
    errorSnackbar,
    successSnackbar,
    warningSnackbar,
    infoSnackbar
  }
}

export default useSnackbar;